import api from '@api/api';
import { Program } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const usePrograms = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<Program>({
    queryKeyRoot: 'programs',
    apiFn: (params) => api.getPrograms(params),
    date,
  });

  return { programs: data, isFetching, error, ...rest };
};

export default usePrograms;
